import { ItListStatus } from 'types/graphql'

import { navigate } from '@redwoodjs/router'
import { useMutation } from '@redwoodjs/web'

import { toast } from 'src/components/widgets/Toaster'

import { useAnalytics } from '../analytics/useAnalytics'

const DELETE_ITLIST_MUTATION = gql`
  mutation DeleteItListMutation($id: Int!) {
    deleteItList(id: $id) {
      id
      status
      liveVersion {
        id
      }
    }
  }
`

type DeleteMutationData = {
  deleteItList: {
    id: number
    status: ItListStatus
    liveVersion: { id: number }
  }
}

type DeleteMutationVariables = { id: number }

type DeleteMutationOperationResult = MutationOperationResult<
  DeleteMutationData,
  DeleteMutationVariables
>

export default function useDeleteItList(
  options?: GraphQLMutationHookOptions<
    DeleteMutationData,
    DeleteMutationVariables
  > & { redirectUrl?: string }
): DeleteMutationOperationResult {
  const { redirectUrl, ...mutationOptions } = options || {}
  const { track } = useAnalytics()

  return useMutation<DeleteMutationData, DeleteMutationVariables>(
    DELETE_ITLIST_MUTATION,
    {
      onCompleted({ deleteItList: { id, status, liveVersion } }) {
        track({
          eventName: 'ItList Deleted',
          props: {
            productId: `${id}`,
            itListStatus: status,
            hasLiveVersion: !!liveVersion,
          },
        })
        toast('success', 'ItList deleted')
        redirectUrl && navigate(redirectUrl)
      },
      ...mutationOptions,
    }
  )
}
